import { render, staticRenderFns } from "./GenerateProjectionsForm.vue?vue&type=template&id=621bf5ba&scoped=true&"
import script from "./GenerateProjectionsForm.vue?vue&type=script&lang=js&"
export * from "./GenerateProjectionsForm.vue?vue&type=script&lang=js&"
import style0 from "./GenerateProjectionsForm.vue?vue&type=style&index=0&id=621bf5ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621bf5ba",
  null
  
)

export default component.exports